import { render, staticRenderFns } from "./EModalJustificarFaltaProfessorPlanejamento.vue?vue&type=template&id=eb43ce38&scoped=true"
import script from "./EModalJustificarFaltaProfessorPlanejamento.vue?vue&type=script&lang=js"
export * from "./EModalJustificarFaltaProfessorPlanejamento.vue?vue&type=script&lang=js"
import style0 from "./EModalJustificarFaltaProfessorPlanejamento.vue?vue&type=style&index=0&id=eb43ce38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb43ce38",
  null
  
)

export default component.exports